import { UpcomingAppointmentsModel } from "one-card-upcoming-appointments";

/**
 * 
 * @param count contains the total number of colors needed
 */
export const getColorCode = (count: number) => {
    let hexcodes: string[] = ['#fcfbd4','#c6f2aa','#f8a768','#f0c2b9','#a7b8d1'];
    return hexcodes.slice(0, count);
}

/**
 * This Function transforms the backend response
 * in the Data Model that supports the 
 * upcoming Appointments Component
 * @param response has the backend upcoming 
 * appointment response
 * @param context has settings etc..
 */

interface ProviderID {
    ID: string;
    Type:string;
    // ... other properties
  }
  interface DeptID {
    ID: string;
    Type:string;
    // ... other properties
  }
  interface VisitID {
    ID: string;
    Type:string;
    // ... other properties
  }
interface Provider{
    ProviderName: string,
    DepartmentName: string,
    Time: string,
    Duration: string,
    ProviderIDs: ProviderID[],
    DepartmentIDs: DeptID[],
    VisitTypeID:VisitID[]
}
export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    const { settings:{appointment_config:{filterAppointments}}} = context;

    let result: UpcomingAppointmentsModel = {};
        let totalupcomingappointments: number = 0;
        let noShowCount: number = 0;
        let pastCount: number = 0;
        let completecount: number = 0;
        let upcomingCount: number = 0;
        let cancelledCount: number = 0;
        let data = {};
        let note:string = "";
        let upappointment: any = [];
        if (response && response.length > 0) {
            response.map((ele: any) => {
                let presentdate: number = new Date().getTime();
                let ddate: string = ele?.Date ? ele.Date : "";
                let dtime: string = ele?.AppointmentStartTime ? ele.AppointmentStartTime : "";
                let apptdate: number = new Date(ddate.concat(" ").concat(dtime)).getTime();
                if (presentdate <= apptdate && (ele.AppointmentStatus === "Scheduled")) {
                    let ehrProvider = sessionStorage.getItem('ehr');
                    let preconfigproviderid=Object.keys(filterAppointments[ehrProvider][0]);
                    let preconfigprovidervalue=filterAppointments[ehrProvider][0]["configuredProviderId"];
                    let preconfigdeptid=Object.keys(filterAppointments[ehrProvider][1]);
                    let preconfigdeptvalue=filterAppointments[ehrProvider][1]["configuredDeptId"];
                    let preconfigvisitid=Object.keys(filterAppointments[ehrProvider][2]);
                    let preconfigvisitvalue=filterAppointments[ehrProvider][2]["configuredVisitId"];
                    if(Array.isArray(preconfigprovidervalue) && preconfigprovidervalue.length>0){
                        if(preconfigproviderid[0]==="configuredProviderId" && preconfigprovidervalue.length>0){
                            ele["Providers"].forEach((p:Provider,index:number)=>{
                                for (var i=0;i<p["ProviderIDs"].length;i++){
                                    if(preconfigprovidervalue.includes(p["ProviderIDs"][i]["ID"].trim())){
                                        totalupcomingappointments += 1;
                                        break;
                                    }
                                }

                            }) 
                     }
                    }
                    else if(Array.isArray(preconfigdeptvalue) && preconfigdeptvalue.length > 0) {
                        if(preconfigdeptid[0]==="configuredDeptId" && preconfigdeptvalue.length>0){
                            ele["Providers"].forEach((p:Provider,index:number)=>{
                                for (var i=0;i<p["DepartmentIDs"].length;i++){
                                    if(preconfigdeptvalue.includes(p["DepartmentIDs"][i]["ID"].trim())){
                                        totalupcomingappointments += 1;
                                        break;
                                    }
                                }
    
                         }) 
                    }
                    
                    }
                    else if(Array.isArray(preconfigvisitvalue) && preconfigvisitvalue.length > 0) {
                        if(preconfigvisitid[0]==="configuredVisitId" && preconfigvisitvalue.length>0){
                            // ele["VisitTypeIDs"].map((p:Provider,index:number)=>{
                                for (var i=0;i<ele["VisitTypeIDs"].length;i++){
                                    if(preconfigvisitvalue.includes(ele["VisitTypeIDs"][i]["ID"].trim())){
                                        totalupcomingappointments += 1;
                                        break;
                                    }
                                }
    
                        //  }) 
                    }
                    
                    }
                    else{
                        totalupcomingappointments += 1;
                    }
                    let appointmentinfo = {
                        appointmentdate: new Date(ele?.Date).toLocaleDateString('en-us',{month:'short', day: 'numeric'}),
                        appointmenttime: ele?.AppointmentStartTime
                    }
                    upappointment.push(appointmentinfo);
                    note = `Next Appointment: ${upappointment[0].appointmentdate},${upappointment[0].appointmenttime}`
                }
                if (ele?.AppointmentStatus) {
                    if (ele.AppointmentStatus === "No Show") {
                        noShowCount = noShowCount + 1;
                    }
                    else if (ele.AppointmentStatus === "Completed") {
                        pastCount = pastCount + 1;
                    }
                    else if (ele.AppointmentStatus === "Arrived") {
                        completecount = completecount + 1;
                    }
                    else if ((ele.AppointmentStatus === "Scheduled")) {                               
                        upcomingCount = upcomingCount + 1;
                    }
                    else if (ele.AppointmentStatus === "Canceled") {
                        cancelledCount = cancelledCount + 1;
                    }
                }
            });
        }
        result['totalupcomingappointments'] = totalupcomingappointments;
        result['totalcancelappointments'] = cancelledCount;
        result['totalnoshow'] = noShowCount;
        result['note'] = note;
        result['chartdata'] = {
                labels: ["No Shows", "Completed", "Arrived", "Scheduled","Canceled"],
                datasets: [{
                    data: [noShowCount,pastCount,completecount,upcomingCount,cancelledCount],
                    backgroundColor: getColorCode(5),
                }]
        }
        console.log("-----Appt Upcoming",result)
    return result;


}